<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="538px"
    :before-close="handleClose"
    custom-class="el-dialog--customize"
  >
    <div class="dialog-container">
      <div class="dialog-tip">
        <i class="el-icon-warning-outline"></i>
        <span>{{ tips }}</span>
      </div>
      <div class="dialog-content">
        <div
          v-for="item in tabs"
          :key="item.type"
          :style="{
            'margin-bottom': goods[item.type].length > 0 ? '10px' : '0px'
          }"
        >
          <el-checkbox
            v-if="goods[item.type].length > 0"
            v-model="selectAll[item.type]"
            @change="handleSelectAll($event, item.type)"
            :indeterminate="getIndeterminate(item.type)"
            >{{ item.name }}</el-checkbox
          >
          <div class="ccui-radio-button-border">
            <div class="radio-button-group">
              <el-checkbox-group
                v-model="ruleForm[item.type]"
                size="small"
                @change="handleSelect($event, item.type)"
              >
                <el-checkbox
                  v-for="(item, index) in goods[item.type]"
                  :label="item.skuId"
                  :key="index"
                  border
                >
                  <img
                    class="goods-img"
                    :title="item.skuTitle"
                    :src="item.ossSkuMainPic | goodsPicFormat"/><i
                    class="icon-ccui-check"
                  ></i>
                  <div></div
                ></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <div class="dialog-footer-info">
        <span>已选商品：</span>
        <span class="selected-count">{{ selectedCount }}</span>
      </div>
      <el-button type="primary" @click="handleConfirm"
        >移到关注的商品</el-button
      >
      <el-button @click="handleDelete">删除</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getMyCartFocusSkuList,
  moveToMyFocusFromCart,
  checkShopStatus,
  deleteSku
} from "@/api/emc-api";
export default {
  name: "clear-goods",
  props: {},
  data() {
    return {
      modalType: 1, // 1-快速清理 2-商品变化
      ruleForm: {
        noStockList: [], //无货-商品
        offLoadingList: [], //下架-商品
        thirtyDaysAgoList: [], //超30天-商品
        priceChangeList: [] //价格变化商品
      },
      selectAll: {
        noStockList: false,
        offLoadingList: false,
        thirtyDaysAgoList: false,
        priceChangeList: false
      },
      dialogVisible: false,
      goods: {
        noStockList: [],
        offLoadingList: [],
        thirtyDaysAgoList: [],
        priceChangeList: []
      }
    };
  },
  computed: {
    title() {
      return this.modalType == 1 ? "快速清理" : "商品变化提示";
    },
    tips() {
      return this.modalType == 1
        ? "购物车堆积的商品较多，请理一下购物车更方便"
        : "商品变动较多，快速清理便于提交订单";
    },
    tabs() {
      const obj1 = [
        { name: "无货商品", type: "noStockList" },
        { name: "下架商品", type: "offLoadingList" },
        { name: "30天前加入购物车", type: "thirtyDaysAgoList" }
      ];
      const obj2 = [
        { name: "无货商品", type: "noStockList" },
        { name: "下架商品", type: "offLoadingList" },
        { name: "商品价格变化", type: "priceChangeList" }
      ];
      return this.modalType == 1 ? obj1 : obj2;
    },
    selectedCount() {
      return this.selectedGoods.length;
    },
    selectedGoods() {
      return [
        ...this.ruleForm.noStockList,
        ...this.ruleForm.offLoadingList,
        ...this.ruleForm.thirtyDaysAgoList,
        ...this.ruleForm.priceChangeList
      ];
    }
  },
  created() {
    // this.init();
  },
  watch: {},
  methods: {
    init() {
      getMyCartFocusSkuList({}).then(res => {
        if (res.data.code == "0") {
          const {
            noStockList,
            offLoadingList,
            thirtyDaysAgoList,
            priceChangeList
          } = res.data.data;
          this.goods = {
            noStockList,
            offLoadingList,
            priceChangeList,
            thirtyDaysAgoList
          };
          if (
            noStockList.length > 0 ||
            offLoadingList.length > 0 ||
            thirtyDaysAgoList.length > 0 ||
            priceChangeList.length > 0
          ) {
            this.dialogVisible = true;
          }
        }
      });
    },
    checkShopStatus(skuIds) {
      return new Promise((resolve, reject) => {
        this.modalType = 2;
        checkShopStatus({ skuIds, isShowLoading: true })
          .then(res => {
            if (res.data.code == "0") {
              const {
                noStockList,
                offLoadingList,
                thirtyDaysAgoList,
                priceChangeList,
                hasChange
              } = res.data.data;
              this.goods = {
                noStockList,
                offLoadingList,
                priceChangeList,
                thirtyDaysAgoList
              };
              if (hasChange == 1) {
                this.dialogVisible = true;
                reject();
              } else {
                resolve();
              }
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.ruleForm.noStockList = [];
      this.ruleForm.offLoadingList = [];
      this.ruleForm.thirtyDaysAgoList = [];
      this.ruleForm.priceChangeList = [];

      this.selectAll.noStockList = false;
      this.selectAll.offLoadingList = false;
      this.selectAll.thirtyDaysAgoList = false;
      this.selectAll.priceChangeList = false;

      this.goods.noStockList = [];
      this.goods.offLoadingList = [];
      this.goods.thirtyDaysAgoList = [];
      this.goods.priceChangeList = [];
    },
    getIndeterminate(name) {
      return (
        this.ruleForm[name].length > 0 &&
        this.goods[name].length !== this.ruleForm[name].length
      );
    },
    handleSelect(val, name) {
      console.log("handleSelect", val, name);
      let value = false;
      if (
        this.ruleForm[name].length > 0 &&
        this.ruleForm[name].length === this.goods[name].length
      ) {
        value = true;
      }
      this.selectAll[name] = value;
    },
    handleSelectAll(val, name) {
      console.log("handleSelectAll", val);
      const data = val ? this.goods[name].map(v => v.skuId) : [];
      this.ruleForm[name] = data;
    },
    handleConfirm() {
      // 获取所有选中的商品
      if (this.selectedCount === 0) {
        return this.$message({
          showClose: true,
          message: "请选中商品移入！",
          type: "error",
          ccuiCustom: true
        });
      }
      this.moveToMyFocusFromCart();
    },
    handleDelete() {
      // 获取所有选中的商品
      if (this.selectedCount === 0) {
        return this.$message({
          showClose: true,
          message: "请选中商品删除！",
          type: "error",
          ccuiCustom: true
        });
      }
      this.deleteSku();
    },
    moveToMyFocusFromCart() {
      moveToMyFocusFromCart({ skuIds: this.selectedGoods }).then(res => {
        if (res.data.code == "0") {
          this.$message({
            message: res.data.message,
            type: "success",
            showClose: true,
            ccuiCustom: true
          });
          this.handleClose();
          this.$emit("clear", this.selectedGoods, this.modalType);
        }
      });
    },
    deleteSku() {
      deleteSku({ skuIds: this.selectedGoods }).then(res => {
        if (res.data.code == "0") {
          this.$message({
            message: res.data.message,
            type: "success",
            showClose: true,
            ccuiCustom: true
          });
          this.handleClose();
          this.$emit("clear", this.selectedGoods, this.modalType);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-tip {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: #4a4a4a;
  .el-icon-warning-outline {
    color: #f08d00;
    font-size: 28px;
    font-weight: 600;
  }
  span {
    vertical-align: text-bottom;
    margin-left: 10px;
  }
}
.dialog-content {
  border: 1px solid #eaeaea;
  padding: 16px 20px;
  margin-top: 10px;
}
.goods-img {
  width: 100%;
  line-height: 60px;
  height: 100%;
  border: 1px solid #eaeaea;
  object-fit: cover;
  object-position: center;
}
.radio-button-group {
  /deep/.el-checkbox {
    margin-right: 0px;
    height: auto !important;
    margin-top: 10px;
    &:nth-of-type(5n + 1) {
      margin-left: 0;
    }
  }
  /deep/.el-checkbox__label {
    width: 80px !important;
    height: 80px !important;
    padding: 5px !important;
    box-sizing: border-box;
  }
  /deep/.is-checked {
    .el-checkbox__label {
      border-width: 2px;
    }
  }
  /deep/.el-checkbox-group {
    flex-wrap: wrap;
  }
}
/deep/.el-dialog__body {
  min-height: 215px;
}
.dialog-footer-info {
  float: left;
  font-size: 14px;
  .selected-count {
    color: #ff142f;
    font-weight: 600;
  }
}
</style>
